import React from 'react';
import PropTypes from 'prop-types';
import { Provider as AccordionProvider } from './AccordionCtx';
import AccordionListener from './AccordionListener';

const Accordion = ({
  children,
  open,
  collapseSiblings,
  onChange,
}) => {
  const accordionState = Object.freeze({
    open,
    collapseSiblings,
    onChange,
  });

  return (
    <AccordionProvider defaultState={accordionState}>
      <AccordionListener />
      {children}
    </AccordionProvider>
  );
};

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  open: PropTypes.bool,
  collapseSiblings: PropTypes.bool,
  onChange: PropTypes.func,
};

const defaultProps = {
  children: null,
  collapseSiblings: true,
  open: false,
  onChange: () => {},
};

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;
export default Accordion;
